(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const bind = () => {
    document.querySelectorAll('[data-ambient-group]').forEach(group => {
      if (group.dataset.ambientBound) return;
      group.dataset.ambientBound = 'true';
      let visible = false;
      const players = [...group.querySelectorAll('[data-ambient-video]')].map(video => {
        const state = {video, started:false, resume:false, resumeTab:false};
        video.addEventListener('play', () => { state.started = true; video.setAttribute('aria-pressed', 'true'); });
        video.addEventListener('pause', () => video.setAttribute('aria-pressed', 'false'));
        const toggle = () => {
          if (video.paused) play(state);
          else { state.resume = false; state.resumeTab = false; video.pause(); }
        };
        video.addEventListener('click', toggle);
        video.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); toggle(); }
        });
        return state;
      });
      const load = state => {
        const video = state.video;
        if (video.dataset.poster) { video.setAttribute('poster', video.dataset.poster); video.removeAttribute('data-poster'); }
        let changed = false;
        video.querySelectorAll('source[data-src]').forEach(source => {
          source.setAttribute('src', source.dataset.src);
          source.removeAttribute('data-src');
          changed = true;
        });
        if (changed) video.load();
      };
      const preload = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        players.forEach(load);
        preload.disconnect();
      }, {rootMargin:'400px'});
      preload.observe(group);
      const play = state => { load(state); state.started = true; state.video.play().catch(() => {}); };
      new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting);
        players.forEach(state => {
          if (!visible) { state.resume = !state.video.paused; state.video.pause(); }
          else if (!reduced.matches && !document.hidden && (!state.started || state.resume)) { state.resume = false; play(state); }
        });
      }, {threshold:.15}).observe(group);
      document.addEventListener('visibilitychange', () => players.forEach(state => {
        if (document.hidden) { state.resumeTab = !state.video.paused; state.video.pause(); }
        else if (visible && state.resumeTab && !reduced.matches) { state.resumeTab = false; play(state); }
      }));
      reduced.addEventListener('change', () => { if (reduced.matches) players.forEach(state => { state.resume = false; state.resumeTab = false; state.video.pause(); }); });
    });
    document.querySelectorAll('[data-wedding-gallery]').forEach(gallery => {
      if (gallery.dataset.galleryBound) return;
      gallery.dataset.galleryBound = 'true';
      const track = gallery.querySelector('.wedding-gallery-track');
      gallery.querySelectorAll('[data-gallery-direction]').forEach(button => button.addEventListener('click', () => {
        track.scrollBy({left:track.clientWidth * Number(button.dataset.galleryDirection),behavior:reduced.matches ? 'instant' : 'smooth'});
      }));
    });
  };
  bind();
  document.addEventListener('shopify:section:load', bind);
})();
